<template>
  <div>
    <div class="modal-window" v-if="!profilesLoaded">
      <Loader />
      <p>Ładowanie profili użytkownika...</p>
    </div>
    <div v-else-if="profilesCount > 0" class="dashboard-wrapper">
      <div class="dashboard-left">
        <Profile/>
        <ModuleMenu/>
      </div>
      <div class="dashboard-window dashboard-right">
        <router-view class="dashboard-content"/>
      </div>
    </div>
    <div class="modal-window" v-else-if="connectionError">
      <p class="error">Nie można połączyć się z serwerem FollowUP.</p>
      <p class="error">Prosimy sprawdzić stan połączenia sieciowego lub skontaktować
        się z naszą pomocą techniczną pod adresem biuro@followup.social</p>
    </div>
    <div class="modal-window" v-else-if="unknownError">
      <p class="error">Wystąpił nieznany błąd.</p>
      <p class="error">Prosimy skontaktować się z naszą pomocą
        techniczną pod adresem biuro@followup.social</p>
    </div>
    <div v-else>
      <AddFirstProfileDialog />
    </div>
  </div>
</template>

<script>
import AddFirstProfileDialog from "@/components/dialogs/AddFirstProfileDialog.vue";
import Loader from "@/components/Loader.vue";
import ModuleMenu from "@/components/ModuleMenu.vue";
import Profile from "@/components/Profile.vue";

export default {
  name: "Dashboard",
  created() {
    this.getUsersProfiles();
  },
  components: {
    Profile,
    ModuleMenu,
    Loader,
    AddFirstProfileDialog
  },
  data() {
    return {
      profilesLoaded: false
    };
  },
  computed: {
    desktop() {
      return this.$store.getters.isDesktop;
    },
    profilesCount() {
      return this.$store.getters.profiles.length;
    }
  },
  methods: {
    getUsersProfiles() {
      this.connectionError = false;
      this.unknownError = false;
      this.$store.dispatch('getUsersProfiles')
        .then(() => {
          this.profilesLoaded = true;
        })
        .catch((err) => {
          this.profilesLoaded = true;
          if (!err.response) this.connectionError = true;
          else this.unknownError = true;
        });
    }
  }
};
</script>

<style lang="scss" scoped>

.dashboard-wrapper {
  margin-top: 70px;
  display: grid;
  grid-template-columns: 1fr 4fr;
  grid-gap: 5px;
  padding: 5px;
  overflow: auto;
  @media only screen and (max-width: 768px) {
    grid-template-columns: 100%;
  }
  @media only screen and (min-width: 1024px) {
    height: calc(100vh - 70px);
  }
}

.dashboard-window {
  background-color: #2a2a2a;
  border-radius: 10px;
}

.dashboard-left {
  min-height: 630px;
  @media only screen and (max-width: 768px) {
    min-height: 0;
  }
}

.dashboard-right {
  min-height: 635px;
  @media only screen and (max-width: 768px) {
    min-height: 0;
  }
}

.dashboard-content {
  height: 100%;
  overflow: auto;
}

.loader {
  margin: 50px auto;
}

</style>
